.kdx-card-link {
	display: block;
	text-decoration: none;
	color: inherit;
	@include text-size(14);
	@include line-height(22);
	@include transitionDefault(color);

	.kdx-card {
		height: 100%;

		&.hover {

			.card-photo {
				&::before { opacity: .5; }
			}
		}
		.card-photo {
			position: relative;
			width: 100%;

			img {
				width: 100%;
				object-fit: cover;
				object-position: center center;
			}

			&::before {
				content: '';
				background: $navCard_overlayBG;
				position: absolute;
				z-index: 2;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				opacity: 0;
				transition: opacity .3s ease-in-out;
			}
        .photo {
          height: 300px;
        }
		}
		.card-body {
			position: relative;
			padding: 24px;

			&::before {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				height: 3px;
				width: 100%;
				background: $navCard_dividerColor;
			}

			p:last-of-type {
				padding: 0;
			}
			.card-title {
				@include text-size(20);
				@include line-height(32);
				font-weight: 700;
				padding-bottom: 0;

				&::after { display: none; }
				a {
					display: flex;
					align-items: center;
					justify-content: space-between;
					text-decoration: none;

					&:hover, &:focus {
						text-decoration: underline;
						outline: none;

						svg { transform: translateX(4px); }
					}

					svg {
						@include svg-format(15px, 15px, currentColor);
						transition: transform .3s ease-in-out;
					}
				}
			}
		}

		.card-footer {
			p {
				padding: 0;
			}

			.svg-icon {
				margin: 0 0 0 5px;

				svg {
				fill: $gray-dark;
				max-height: 10px;
				max-width: 10px;
				min-width: 10px;
				}
			}
		}
	}


	.frontend-comp {
		text-align: center;

		img { max-height: 400px; }
	}


}







@include media-breakpoint-down(md) {
	.kdx-card-link {

		.kdx-card {
			@include text-size(12);
			@include line-height(18);

			.card-body {
				padding: 16px;

				.card-title {
					@include text-size(15);
					@include line-height(24);
				}
			}

			.card-footer {
				padding: 5px 16px 16px;
			}
		}
	}
}




@include media-breakpoint-down(md) {
	.kdx-card-link {

		.kdx-card {

			.card-photo {
				&.hide-on-mobile { display: none; }
			}
		}
	}
}
